import { createContext, useContext } from "react";

const SettingsInDialogContext = createContext(false);

export function useSettingsInDialog(): boolean {
  return useContext(SettingsInDialogContext);
}

export const SettingsInDialogProvider = SettingsInDialogContext.Provider;
